import { Drawer, DRAWER_WIDTH } from '@toggle/design-system';
import styled from 'styled-components';

export interface ExpandableDrawerStyledProps {
  $isExpanded: boolean;
  $defaultWidth?: number;
}

const EXPANDED_WIDTH = '90vw';

export const StyledDrawer = styled(Drawer)<ExpandableDrawerStyledProps>`
  [data-drawer-container] {
    width: ${({ $isExpanded, $defaultWidth = DRAWER_WIDTH }) =>
      $isExpanded ? EXPANDED_WIDTH : `${$defaultWidth}px`};
    transition: width 0.3s ease-out;

    [data-drawer-header] {
      background-color: ${({ $isExpanded }) =>
        $isExpanded ? 'var(--background-default)' : 'var(--background-soft)'};
    }
  }
`;
